import { Debouncer } from "../submodules/fox-typescript/utils/Debouncer";

export const debounce = (fn: Function, ms = 1000) => {
  const debouncer = new Debouncer(ms);

  return function (this: any, ...args: any[]) {
    debouncer.debounce(() => fn.apply(this, args));
  };
};
